/**
 * P3-2 我的长周期客户（养客户库）
 */
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { $ } from '../../lib/api';
import { fmtRelative } from '../../lib/format';
import { HomeCard, Pill } from '../ui';

export function LongCycleCard() {
  const { data } = useQuery<any[]>({
    queryKey: ['long-cycle-customers'],
    queryFn: () => $.get('/customer-protection/long-cycle-customers'),
  });
  if (!data || data.length === 0) return null;
  return (
    <HomeCard title={<>🌱 长周期客户（养客户库） <span style={{ fontSize: 12, color: 'var(--text-3)', fontWeight: 400, marginLeft: 6 }}>{data.length} 个客户·维系关系而非逼单</span></>}>
      <div style={{ padding: 12 }}>
        {data.slice(0, 8).map((c) => (
          <Link key={c.id} to={`/customers/${c.id}`} style={{ textDecoration: 'none' }}>
            <div style={{
              padding: '8px 12px', marginBottom: 6, borderRadius: 4,
              background: 'rgba(124,77,255,0.04)', borderLeft: '3px solid var(--purple)',
              display: 'flex', alignItems: 'center', gap: 8,
            }}>
              <span style={{ flex: 1 }}>{c.nickname}</span>
              <Pill tone="default">{c.currentStage}</Pill>
              <span style={{ fontSize: 11, color: 'var(--text-3)' }}>
                {c.lastFollowupAt ? fmtRelative(c.lastFollowupAt) + '联系' : '未联系'}
              </span>
              <span style={{ fontSize: 11, color: 'var(--purple)' }}>
                加微信 {dayjs().diff(dayjs(c.assignedAt ?? c.createdAt), 'day')} 天
              </span>
            </div>
          </Link>
        ))}
      </div>
    </HomeCard>
  );
}
